import React from 'react'
import { Container, Button, Label } from '@sencha/ext-modern'
const style = {
    outer: {
        backgroundColor: "#f5f5f5",
        paddingTop: "10px",
        paddingBottom: "10px"
    },
    innerContainer: {
        borderRadius: "10px",
        backgroundColor: "#ffffff",
        margin: "10px",
    },
    titleContainer: {
        borderBottom: "1px solid #f5f5f5",
    },
    titleSmall: {
        margin: 0,
        fontSize: "14px",
    },
    contentContainer: {
        padding: "10px",
        fontSize: "12px",
        color: '#838484'
    },
    checked: {
        color: "#37a1f2",
        paddingTop: "5px"
    },
    unchecked: {
        color: "#959595",
        paddingTop: "5px"
    }
}
function ListItem(props) {
    const { dataList, totalCount, handleLoadMore, handleChildTap } = props
    return (
        <Container layout={{ type: "vbox" }}>
            {dataList && dataList.map((o, index) => {
                return (
                    <Container key={index} layout={{ type: "vbox" }} style={style.innerContainer} >
                        {o.number &&
                            <Container layout={{ type: "hbox", pack: "space-between" }} style={style.titleContainer} >
                                <Container layout={{ type: "hbox", pack: "start" }}>
                                    <Container layout="center" padding="10"><i style={{ color: '#fbb805' }} className={"fa fa-envelope"} ></i></Container>
                                    <Container layout="center" padding="0 10 0 0"><h6 style={style.titleSmall}>{o.number}</h6></Container>
                                </Container>
                            </Container>}
                        <Container layout={{ type: 'vbox', pack: 'start' }} style={style.contentContainer}>
                            {o.fields && Object.keys(o.fields).map((key, index) => {
                                return (<Label cls="label" key={index} html={key + ': ' + o.fields[key]} padding="0 0 3 0" />)
                            })}
                        </Container>
                        <Container layout={{ type: "hbox", pack: "space-between" }} >
                            <Container layout={{ type: "hbox", pack: "start" }}  ><div style={style.contentContainer} onClick={() => { handleChildTap(o.id, o.type) }}>详情</div></Container>
                            <Container layout="center" ><div style={style.contentContainer} onClick={() => { handleChildTap(o.id, o.type) }}>＞</div></Container>
                        </Container>
                    </Container>
                )
            })}
            {totalCount > dataList.length && <Container layout="center">
                <Button ui="" text="加载更多..." handler={() => handleLoadMore()} />
            </Container>}
        </Container>
    )
}
export default ListItem

